export const environment = {
  production: false,
  baseUrl: "http://187.86.54.241:3010",
  port: 3010
};
